(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateComparisonHints() {
      document.querySelectorAll('[data-compare]').forEach(function (root) {
        var table = root.querySelector('[data-compare-scroll]');
        var hint = root.querySelector('[data-compare-hint]');
        if (!table || !hint) return;
        hint.classList.toggle('scroll-on', table.scrollWidth > table.clientWidth + 1);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateComparisonHints);
    } else {
      updateComparisonHints();
    }
    window.addEventListener('load', updateComparisonHints);
    window.addEventListener('resize', updateComparisonHints);
    document.addEventListener('shopify:section:load', updateComparisonHints);
  })();

  } catch(e) { console.error(e); }
})();
})();
